import { FeatureDetails } from "components/FeatureDetails/FeatureDetails";
import { ChartHistogram } from "components/icons/ChartHistogram";
import { BoxOpen1 } from "components/icons/BoxOpen1";
import { Analyze1 } from "components/icons/Analyze1";
import { VerticalDivider } from "components/design/VerticalDivider";
import { Boxes1 } from "components/icons/Boxes1";
import { Reciept } from "components/icons/Reciept";
import { DashboardPannel } from "components/icons/DashboardPannel";
import { Button } from "components/DesignSystem/Button/Button";
import { CreditCardEye } from "components/icons/CreditCardEye";
import { BigDataAnalytics } from "components/icons/BigDataAnalytics";
import { BooksSoftwareSubscriptionsModal } from "components/BooksSoftwareSubscriptionsModal";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useModal } from "hooks/useModal";
import { UsaMapPin } from "components/icons/UsaMapPin";
import { ComplienceClipboard } from "components/icons/ComplianceClipboard";
import { DashboardMonitor } from "components/icons/DashboardMonitoe";
import { ReactNode } from "react";
import { TimeTwentyFour } from "components/icons/TimeTwentyFour";
import { NewsLetterSubscribe } from "components/icons/NewsLetterSubscribe";
import RevenueMetricsBanner from "static/images/RevenueMetrics.png";

export const LockDescription = ({
  descriptionText,
  title,
}: {
  descriptionText?: ReactNode;
  title?: string;
}) => (
  <div className="t-flex t-flex-col t-gap-2 t-justify-center t-text-center t-w-[25rem] sm:t-w-full">
    <div className="t-text-subtext t-text-text-100">{title}</div>
    <div className="t-text-body-sm t-text-text-30">{descriptionText}</div>
  </div>
);

export const ModalDescriptionWrapper = ({ value }: { value: string }) => (
  <div className="t-text-text-60 t-text-subtext t-pt-1 t-pb-4 t-line-clamp-2">
    {value}
  </div>
);

export const LockFeatures = ({
  type,
  description,
}: {
  type?: string;
  description?: string;
}) => {
  const isDivider = type === "divider";
  const getIcon = () => {
    switch (type) {
      case "analyze":
        return <Analyze1 />;
      case "chart":
        return <ChartHistogram />;
      case "box":
        return <BoxOpen1 />;
      case "boxes":
        return <Boxes1 />;
      case "reciept":
        return <Reciept />;
      case "dashboard":
        return <DashboardPannel />;
      case "creditCard":
        return <CreditCardEye />;
      case "bigData":
        return <BigDataAnalytics />;
      case "usaPin":
        return <UsaMapPin />;
      case "complienceClipboard":
        return <ComplienceClipboard />;
      case "dashboardMonitor":
        return <DashboardMonitor />;
      case "timeTwentyFour":
        return <TimeTwentyFour />;
      case "newsLetter":
        return <NewsLetterSubscribe />;
    }
  };
  return (
    <>
      {!isDivider ? (
        <div className="t-w-[8.875rem] t-flex t-flex-col t-gap-2 t-items-center t-h-full sm:t-w-full sm:t-h-auto sm:t-flex-row sm:t-items-start">
          <div className="t-h-4 t-pb-1 sm:t-shrink-0 sm:t-pb-0">
            {getIcon()}
          </div>
          <div className="t-text-body-sm t-text-text-30 t-text-center t-max-h-[3.375rem] t-self-stretch t-pt-0.5 sm:t-text-left sm:t-max-h-none sm:t-pt-0">
            {description}
          </div>
        </div>
      ) : (
        <div className="sm:t-hidden">
          <VerticalDivider size="xmedium" />
        </div>
      )}
    </>
  );
};

export const RevenueMetricsLocked = () => {
  const entityId = useCurrentEntityId();
  const subscriptionModal = useModal();
  const featureDetails = [
    {
      type: "chart",
      description: "Track MRR and ARR effortlessly",
    },
    {
      type: "divider",
      description: "",
    },
    {
      type: "analyze",
      description: "Identify top revenue-generating customers",
    },
    {
      type: "divider",
      description: "",
    },
    {
      type: "box",
      description: "Measure product-wise performance",
    },
  ];
  const descriptionText =
    "Get a clear view of your revenue, recurring income, and the customers and products behind them.";
  return (
    <section className="t-flex t-justify-center t-items-center t-h-full t-w-full">
      <FeatureDetails
        banner={
          <img
            className="t-w-[22.5625rem] t-h-[13.5rem] t-object-cover t-rounded-tl-xl"
            src={RevenueMetricsBanner}
            alt="RevenueMetricsBanner"
          />
        }
        description={
          <LockDescription
            descriptionText={descriptionText}
            title="Revenue Metrics"
          />
        }
        feature={
          <div className="t-flex t-gap-5 t-w-[31.8125rem] sm:t-w-full sm:t-flex-col sm:t-gap-4 sm:t-max-h-none t-max-h-[5.375rem] t-mx-auto t-items-center">
            {featureDetails.map((feature, index) => (
              <LockFeatures
                key={index}
                type={feature.type}
                description={feature.description}
              />
            ))}
          </div>
        }
        button={
          <Button
            onClick={() => subscriptionModal.open()}
            customType="primary"
            size="regular"
          >
            Upgrade to Inkle Books Standard
          </Button>
        }
      />
      <BooksSoftwareSubscriptionsModal
        open={subscriptionModal.isOpen}
        onClose={() => subscriptionModal.close()}
        entityId={entityId}
        onProductSubscribe={() => subscriptionModal.close()}
        modalDescription={
          <ModalDescriptionWrapper value="Unlock Revenue Metrics and more with Books Standard Plan" />
        }
      />
    </section>
  );
};
